import { useEffect, useState } from "react";

// Empresa que está usando Korvantis (2/11/2026).
// NORMA: cada empresa va independiente. Ninguna pantalla puede llevar fijo el
// nombre, el logo ni el ERP de una empresa (antes salía Coaliment y "AS/400"
// también a Covalco, que trabaja con SAP). Todo sale de aquí.
//   · Comerciales, jefes y admin: lo carga App.js al entrar.
//   · Centros: lo carga CentroPedidos con modulos_empresa (centro-perfil).
const KEY = "kv_empresa";
let actual = (() => {
  try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
})();
const avisos = new Set();

export function setEmpresaActual(e) {
  actual = {
    nombre: e?.nombre || "",
    logo_url: e?.logo_url || "",
    usa_as400: e?.usa_as400 === true,
    erp_nombre: e?.erp_nombre || "",
  };
  try { sessionStorage.setItem(KEY, JSON.stringify(actual)); } catch (x) { /* sin storage */ }
  avisos.forEach((f) => f());
}

// nombre · logo (ruta o URL; "" si no tiene) · erp ("AS/400", "SAP"…) · usaAS400
export function empresaActual() {
  return {
    nombre: actual.nombre || "",
    logo: actual.logo_url || "",
    erp: actual.erp_nombre || (actual.usa_as400 ? "AS/400" : "ERP"),
    usaAS400: actual.usa_as400 === true,
  };
}

// Igual que empresaActual(), pero la pantalla se repinta cuando llegan los datos
export function useEmpresa() {
  const [, repintar] = useState(0);
  useEffect(() => {
    const f = () => repintar((n) => n + 1);
    avisos.add(f);
    return () => avisos.delete(f);
  }, []);
  return empresaActual();
}
